// @flow

type Option = {
  value: string,
  label: string,
};

const languagesOptions: Array<Option> = [
  { value: 'javascript', label: 'Javascript' },
  { value: 'python', label: 'Python' },
  { value: 'rust', label: 'Rust' },
  { value: 'csharp', label: 'C#' },
  { value: 'golang', label: 'Golang' },
  { value: 'java', label: 'Java' },
  { value: 'cpp', label: 'C++' },
  { value: 'scala', label: 'Scala' },
  { value: 'html', label: 'HTML' },
  // { value: 'dart', label: 'Dart' },
  // { value: 'php', label: 'PHP' },
  // { value: 'ruby', label: 'Ruby' },
];
export default languagesOptions;
